import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class RidingKnow extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="RidingKnow">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">乘车须知</div>
                    <div className="first">
                        <div>1、每位乘客允许免费携带25公斤以内体积不大的随身行李，体积不能超过0.25立方米，长度不得超过1米，并以能放置本人座位下或者后备箱内为限。超出规定的部分，平台有权按带货收费，超出部分按1元/公斤收取超重附加费；超过车辆车载范围（以能装后备箱为限）的，平台有权拒绝提供服务。如未备注或未联系客服，一切后果由乘车人自行承担。</div>
                        <div> 2、根据《道路交通安全法》相关规定，以下物品为运输违禁物，请勿携带上车：</div>
                        <div className="textIndent">（1）易燃、易爆、易腐蚀、有毒、管制刀具、压缩气体、液化气体、生化制品、易感染性、有放射性等危险物品，有强烈刺激性气味、恶臭等异味物品，武器等违法物品，精密仪器等贵重物品，非法出版物、印刷品、音像制品等宣传品； </div>
                        <div className="textIndent">（2）摩托车、汽车、电动车等车辆使用的蓄电池，额定能量大于100W/H的锂电池或充电宝；</div>
                        <div className="textIndent">（3）活体动物、尸体、尸骨，如家禽、以及宰杀的各类肉；</div>
                        <div className="textIndent">（4）没有包装、出处不明的液体和粉末及膏状物品；</div>
                        <div className="textIndent">（5）烟、酒；</div>
                        <div className="textIndent">（6）地方性政府规定的临时管制、禁止运输流通的其他物品；</div>
                        <div className="textIndent">（7）《危险化学品目录》《民用爆炸物品品名表》《易制爆危险化学品名录》《易制毒化学品的分类和品种目录》《中华人民共和国禁止进出境物品表》载明的物品和《人间传染的病原微生物名录》载明的第一、二类病原微生物等，以及法律、行政法规、国务院和国务院有关部门规定禁止寄递的其他物品。</div>
                        <div> 3、为了乘车安全，乘车人应遵守以下规定，否则，由此产生的一切后果（包括但不限于安全责任和经济后果）由乘车人（或责任人）自行承担：</div>
                        <div className="textIndent">（1）乘客应在预定时间或与司机约定时间前做好乘车准备，行程途中下车休息应按司机提示准时上车；</div>
                        <div className="textIndent">（2）乘客不得随意挪动、触碰车内设施，如安全锤、报警装置、监控设备等，不得损坏公司、车内设施或他人财物；</div>
                        <div className="textIndent">（3）乘车时要坐稳、扶好，系好安全带，不得将头、手、身伸出车外，不准翻越车窗，不准在车内随意走动、打闹，不准向车窗外乱扔杂物，车内全程禁止吸烟，贵重物品随身携带，车未停稳不准上下车，不准随便开启车门；</div>
                        <div className="textIndent">（4）在车辆行驶过程中，最好不要吃东西，尤其是糖、豆、花生等一类的食品，容易在汽车晃动时呛到气管中；</div>
                        <div className="textIndent">（5）车辆在安全地带停稳后方可解开安全带下车，下车前应先确定车门后方无安全隐患才可开车门；</div>
                        <div className="textIndent">（6）乘客不得私自开启后备箱或挪动他人物品。</div>
                        {/*<div className="colorRed">4、乘客在车辆行驶途中应该严格按照驾驶员的正确规范要求指示乘车，遇到紧急情况时应听从驾驶员的安全指示操作，确保乘客的人身财产安全。</div>*/}
                        {/*<div className="footer">尊敬的旅客：感谢您乘坐民途专车，祝您旅途愉快，安全到达目的地！欢迎下次光临。</div>*/}
                    </div>
                   
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/HelpCenter/RidingKnow/index.js